import {
  SET_USER_LIST_LOADING,
  SET_USER_LIST,
  SET_AREA_LIST_LOADING,
  SET_AREA_LIST,
  SET_PLATFORM_LIST_LOADING,
  SET_SCHEDULE_PLATFORM_LIST,
} from './mutation-types'
import api from '@/api'
const ScheduleType = Object.freeze({
  Platform: 1,
  Area: 2,
  User: 3,
})
const state = {
  userList: [],
  loadingUserList: false,
  platformList: [],
  loadingPlatformList: false,
  areaList: [],
  loadingAreaList: false,
}
const mutations = {
  [SET_USER_LIST](state, payload) {
    state.userList = payload
  },
  [SET_USER_LIST_LOADING](state, payload) {
    state.loadingUserList = payload
  },
  [SET_AREA_LIST_LOADING](state, payload) {
    state.loadingAreaList = payload
  },
  [SET_AREA_LIST](state, payload) {
    state.areaList = payload
  },
  [SET_PLATFORM_LIST_LOADING](state, payload) {
    state.loadingPlatformList = payload
  },
  [SET_SCHEDULE_PLATFORM_LIST](state, payload) {
    state.platformList = payload
  },
}
const actions = {
  async getPlatformScheduleList({ commit }) {
    commit(SET_PLATFORM_LIST_LOADING, true)
    const { data, code } = await api.deployApi.getPlatformOrAreaScheduleList({
      scheduleType: ScheduleType.Platform,
    })
    if (code === 200) {
      commit(SET_SCHEDULE_PLATFORM_LIST, data)
    } else {
      commit(SET_SCHEDULE_PLATFORM_LIST, [])
    }
    commit(SET_PLATFORM_LIST_LOADING, false)
  },
  async getAreaScheduleList({ commit }) {
    commit(SET_AREA_LIST_LOADING, true)
    const { data, code } = await api.deployApi.getPlatformOrAreaScheduleList({
      scheduleType: ScheduleType.Area,
    })
    if (code === 200) {
      commit(SET_AREA_LIST, data)
    } else {
      commit(SET_AREA_LIST, [])
    }
    commit(SET_AREA_LIST_LOADING, false)
  },
  async getTaskScheduleList({ commit }) {
    commit(SET_USER_LIST_LOADING, true)
    const { data, code } = await api.deployApi.getPlatformOrAreaScheduleList({
      scheduleType: ScheduleType.User,
    })
    if (code === 200) {
      commit(SET_USER_LIST, data)
    } else {
      commit(SET_USER_LIST, [])
    }
    commit(SET_USER_LIST_LOADING, false)
  },
  async deleteTaskScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.deleteTaskScheduleList(payload)
    if (data.code === 200) {
      dispatch('getTaskScheduleList')
    }
    return data
  },
  async deleteAreaScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.deleteTaskScheduleList(payload)
    if (data.code === 200) {
      dispatch('getAreaScheduleList')
    }
    return data
  },
  async addTaskScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.addPlatformOrAreaSchedule({
      scheduleType: ScheduleType.User,
      ...payload,
    })
    if (data.code === 200) {
      dispatch('getTaskScheduleList')
    }
    return data
  },
  async addPlatformScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.addPlatformOrAreaSchedule({
      scheduleType: ScheduleType.Platform,
      ...payload,
    })
    if (data.code === 200) {
      dispatch('getPlatformScheduleList')
    }
    return data
  },
  async addAreaScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.addPlatformOrAreaSchedule({
      scheduleType: ScheduleType.Area,
      ...payload,
    })
    if (data.code === 200) {
      dispatch('getAreaScheduleList')
    }
    return data
  },
  async updateUserScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.updateTaskSchedule(payload)
    if (data.code === 200) {
      dispatch('getTaskScheduleList')
    }
    return data
  },
  async updatePlatformScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.updateTaskSchedule(payload)
    if (data.code === 200) {
      dispatch('getPlatformScheduleList')
    }
    return data
  },
  async updateAreaScheduleList({ dispatch }, payload) {
    const data = await api.deployApi.updateTaskSchedule(payload)
    if (data.code === 200) {
      dispatch('getAreaScheduleList')
    }
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
